import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Navbar, Nav, Form, InputGroup } from "react-bootstrap";
import { format } from "date-fns";

import { AlertCircle, Bell, CheckCircle, DollarSign } from "react-feather";

import useSidebar from "../../hooks/useSidebar";

import NavbarDropdown from "./NavbarDropdown";
import NavbarDropdownItem from "./NavbarDropdownItem";
import NavbarLanguages from "./NavbarLanguages";
import NavbarUser from "./NavbarUser";
import useAuth from "../../hooks/useAuth";
import NavbarImpersonation from "./NavbarImpersonation";
import NotificationDropdown from "./NotificationDropdown";
import { useSelector } from "react-redux";
import useWindowSize from "../../hooks/useWindowSize";
import useDeviceType from "../../hooks/useDeviceType";

const NavbarComponent = ({ demoMode = false }) => {
  const { t } = useTranslation();
  const { isOpen, setIsOpen } = useSidebar();
  const { impersonationUser } = useAuth();
  const notifications = useSelector(
    (state) => state.notifications.notifications
  );
  const [width] = useWindowSize();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  return (
    <Navbar variant="light" expand className="navbar-bg">
      {isDesktop && (
        <span
          className="sidebar-toggle d-flex"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <i className="hamburger align-self-center" />
        </span>
      )}

      <Navbar.Collapse>
        <Nav className="navbar-align">
          {demoMode === false && (
            <NotificationDropdown
              header="Notifications"
              footer="Show all notifications"
              icon={Bell}
            >
              {notifications.slice(0, 5).map((item, key) => {
                let icon = <AlertCircle size={18} className="text-danger" />;
                if (item.type === "INVOICE") {
                  icon = <DollarSign size={18} className="text-primary" />;
                } else if (item.type === "WATCHDOG_WARNING") {
                  icon = <AlertCircle size={18} className="text-warning" />;
                } else if (item.type === "ORDER") {
                  icon = <CheckCircle size={18} className="text-success" />;
                }

                return (
                  <NavbarDropdownItem
                    key={key}
                    icon={icon}
                    title={item.message}
                    time={item.createdAt}
                  />
                );
              })}
            </NotificationDropdown>
          )}
          {demoMode === false && <NavbarLanguages />}
          {demoMode === false && impersonationUser && <NavbarImpersonation />}

          <NavbarUser demoMode={demoMode} />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;
